import React from "react";
import PostReportGeneralInfo from "../GeneralInfo";
import { API, graphqlOperation } from "aws-amplify";
import { updateReport } from "../../../../graphql/mutations";
import { getReport } from "../../../../graphql/queries";
import SoftDelete from "../../../Common/Crud/SoftDelete";

const PostReportDelete = (props) => {
  const deleteOperationalValidation = async (postReportId) => {
    try {
      // extra condition check
      // we should not let admin to delete the OTHER option
      // get the desired postReport
      // let tobeDeleted = await API.graphql(
      //   graphqlOperation(getReport, { id: postReportId })
      // );

      // deleting is permitted
      return true;
    } catch (error) {
      return {
        result: false,
        message: `Error fetching Report data, validation check error, ${JSON.stringify(
          error,
          null,
          2
        )}`,
      };
    }
  };

  return (
    <>
      <SoftDelete
        {...props}
        modelName="Post Report"
        deleteDescription="post report will be deleted. do you want to proceed?"
        returnRoute="/postReports"
        generalInfoComponent={
          <PostReportGeneralInfo
            postReportId={props.match.params.postReportId}
          />
        }
        mutationMethod={updateReport}
        mutationInput={{
          id: props.match.params.postReportId,
        }}
        deleteOperationValidation={async () =>
          await deleteOperationalValidation(props.match.params.postReportId)
        }
      />
    </>
  );
};

export default PostReportDelete;
